import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import lodash from "lodash";
import { getToken } from "firebase/messaging";
import { Box, Grid2 as Grid, Button, Typography, Stack, Tooltip } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon, LocationOn as LocationOnIcon } from "@mui/icons-material";
import { PATH_HOME, GOOGLE_MAPS_BASE_URL } from "../../path";
import {
  getConfig,
  NAVIGATION_FROM_REQUEST_HEADER,
  NOTIFICATION_PERMISSION_SETTED,
  NOTIFICHE_CONCESSE,
  NOTIFICHE_NEGATE,
} from "../../modules/configuration";
import { notificationCodes, setNotification } from "../../modules/notification";
import {
  ID_OSPEDALE_JSON,
  NOME_OSPEDALE_JSON,
  INDIRIZZO_OSPEDALE_JSON,
  CIVICO_OSPEDALE_JSON,
  CAP_OSPEDALE_JSON,
  COMUNE_OSPEDALE_JSON,
  PROVINCIA_OSPEDALE_JSON,
  getElencoProntoSoccorso,
  ID_PAZIENTE,
} from "../../modules/prontoSoccorso";
import {
  getLocale,
  BACK,
  LAST_UPDATE,
  NAVIGA,
  CODICE_EMERGENZA,
  STATO_PAZIENTE,
  PRONTO_SOCCORSO,
  ACCESSO_PS,
  POSIZIONE,
  PRESTAZIONI_LABEL,
  CODICE_EMERGENZA_BIANCO,
  CODICE_EMERGENZA_VERDE,
  CODICE_EMERGENZA_AZZURRO,
  CODICE_EMERGENZA_ARANCIONE,
  CODICE_EMERGENZA_ROSSO,
  SAGAS_CHECK_SUBSCRIPTION_ERROR_TITLE,
  SAGAS_CHECK_SUBSCRIPTION_ERROR_DESCRIPTION,
  SAGAS_SUBSCRIPTION_ERROR_TITLE,
  SAGAS_SUBSCRIPTION_ERROR_DESCRIPTION,
  SAGAS_UNSUBSCRIPTION_ERROR_TITLE,
  SAGAS_UNSUBSCRIPTION_ERROR_DESCRIPTION,
  EVENT_COMPLETED_LABEL,
} from "../../modules/language";
import {
  CODICE_EVENTO,
  ID_OSPEDALE,
  INIZIALI_PAZIENTE,
  STATO,
  LAST_UPDATE_TIMESTAMP,
  TIMESTAMP_TRIAGE,
  LUOGO,
  CODICE_COLORE,
  PRESTAZIONI,
  IS_NAVIGATION_FROM_FORM,
  EVENT_COMPLETED,
  CODICE_DIALOG,
  CODICE_MESSAGGIO,
  ARGOMENTI_STATO_O_DIALOG,
  PREFIX_DIALOG,
  PREFIX_MESSAGGIO,
  PREFIX_STATO_PAZIENTE,
  PS_CHANGED,
  CODICE_COLORE_CHANGED,
  STATO_PAZIENTE_CHANGED,
  POSIZIONE_CHANGED,
  SUBSCRIBE_EVENT,
  UNSUBSCRIBE_EVENT,
  fetchMonitoraggio,
  fetchUpdateMonitoraggio,
  azzeraMonitoraggio,
  fetchMonitoraggioEnded,
  getMonitoraggio,
  getOpenedNotification,
  estraiParametriFineEpisodio,
} from "../../modules/tracking";
import { GoogleMapsModalAlert, ModaleEventiMonitoraggio, ModaleFollowUp, Tridimensional } from "./monitoraggio/";
import { firebaseMessaging, getMessageString } from "../../utility";
import { Banners, Icona, LoadingSpinner } from "../shared";
import { CHECK_SUBSCRIPTION_API, SUBSCRIBE_API, UNSUBSCRIBE_API } from "../../apiUrl";

export const Monitoraggio = injectIntl(({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pollingInterval = useRef(null);
  const [dispatchOnReaload, setDispatchOnReaload] = useState(false);
  const [googleMapsModalOpen, setGoogleMapsModalOpen] = useState(false);
  const [ps, setPs] = useState(null);
  const [eventCompleted, setEventCompleted] = useState(false);
  const [followUpModalOpen, setFollowUpModalOpen] = useState(false);
  const [firebaseToken, setFirebaseToken] = useState(null);
  const config = useSelector(getConfig);
  const monitoraggio = useSelector(getMonitoraggio);
  const fetchEnded = useSelector(fetchMonitoraggioEnded);
  const elencoPs = useSelector(getElencoProntoSoccorso);
  const openedNotification = useSelector(getOpenedNotification);
  const locale = useSelector(getLocale);

  const fromSaluteSimplex = window.ReactNativeWebView != null;
  const notificationPermission = window.Notification?.permission;
  const codiceEvento = monitoraggio ? monitoraggio[CODICE_EVENTO] : null;

  const CodiceTriage = ({ codice }) => {
    let codiceColore = "";
    let labelCodiceColore = "";

    switch (codice?.toString()) {
      case "green":
        codiceColore = "verde";
        labelCodiceColore = CODICE_EMERGENZA_VERDE;
        break;
      case "cyan":
        codiceColore = "azzurro";
        labelCodiceColore = CODICE_EMERGENZA_AZZURRO;
        break;
      case "orange":
        codiceColore = "arancione";
        labelCodiceColore = CODICE_EMERGENZA_ARANCIONE;
        break;
      case "red":
        codiceColore = "rosso";
        labelCodiceColore = CODICE_EMERGENZA_ROSSO;
        break;
      default:
        codiceColore = "bianco";
        labelCodiceColore = CODICE_EMERGENZA_BIANCO;
    }

    return (
      <Stack className="codiceTriage">
        <Stack className={codiceColore} />
        <Typography>{getMessageString(intl, labelCodiceColore)}</Typography>
      </Stack>
    );
  };

  useEffect(() => {
    // Aggiungo il listener per l'eventuale visualizzazione di fine evento
    window.addEventListener(EVENT_COMPLETED, handleEventCompletion);
    // Controllo se la pagina viene ricaricata o meno
    if (sessionStorage.getItem(IS_NAVIGATION_FROM_FORM) === null) {
      if (!dispatchOnReaload) {
        if (window.saluteSimplexEventId != null) dispatch(fetchMonitoraggio({ [ID_PAZIENTE]: window.saluteSimplexEventId }));
        else dispatch(fetchUpdateMonitoraggio());
        setDispatchOnReaload(true);
      }
    } else sessionStorage.removeItem(IS_NAVIGATION_FROM_FORM);
    return () => {
      // Interrompo il polling e il listener dell'evento terminato quando abbandono la pagina
      clearInterval(pollingInterval.current);
      window.removeEventListener(EVENT_COMPLETED, handleEventCompletion);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Aggiungo il listener per l'eventuale revoca del token nel caso in cui le notifiche non sono concesse
    navigator.permissions?.query({ name: "notifications" }).then((permissionStatus) => {
      permissionStatus.onchange = () => {
        if (permissionStatus.state !== NOTIFICHE_CONCESSE) setFirebaseToken(null);
      };
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (monitoraggio) {
      setPs(elencoPs.find((ps) => ps[ID_OSPEDALE_JSON] === monitoraggio[ID_OSPEDALE]));
      // Attivazione polling se l'evento non è terminato
      if (!pollingInterval.current && !eventCompleted) {
        pollingInterval.current = setInterval(() => {
          dispatch(fetchUpdateMonitoraggio());
        }, config.pollingInterval);
      }
    }
    // eslint-disable-next-line
  }, [monitoraggio]);

  useEffect(() => {
    if (firebaseToken) {
      if (codiceEvento) {
        // Se ho sia il token che il codice evento aggiungo i listener per operare la sottoscrizione o la dissociazione del codice evento
        window.addEventListener(SUBSCRIBE_EVENT, handleSubscription);
        window.addEventListener(UNSUBSCRIBE_EVENT, handleUnsubscription);
      }
    } else {
      // Ogniqualvolta il firebase token è nullo (notifiche negate o avvio applicazione) nascondo le campanelline nell'header e rimuovo i listener
      const subButton = document.getElementById("subButton");
      const unsubButton = document.getElementById("unsubButton");
      if (subButton) subButton.style.display = "none";
      if (unsubButton) unsubButton.style.display = "none";
      window.removeEventListener(SUBSCRIBE_EVENT, handleSubscription);
      window.removeEventListener(UNSUBSCRIBE_EVENT, handleUnsubscription);
    }
    return () => {
      // Rimuovo i listener relativi alla sottoscrizione quando abbandono la pagina
      window.removeEventListener(SUBSCRIBE_EVENT, handleSubscription);
      window.removeEventListener(UNSUBSCRIBE_EVENT, handleUnsubscription);
    };
    // eslint-disable-next-line
  }, [firebaseToken, codiceEvento]);

  useEffect(() => {
    // Se ho un codice evento, non vengo chiamato da webview e non ho le notifiche negate chiamo il token se non ce l'ho oppure ricerco gli eventi associati se ce l'ho
    if (codiceEvento && !fromSaluteSimplex && notificationPermission !== NOTIFICHE_NEGATE) {
      if (!firebaseToken) {
        getToken(firebaseMessaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY })
          .then((token) => setFirebaseToken(token))
          .catch((err) => console.log("Errore nella generazione del token", err));
      } else ricercaEventiAssociati(codiceEvento, firebaseToken);
    }
    // eslint-disable-next-line
  }, [codiceEvento, firebaseToken]);

  // Ricerco tutti gli eventi associati al token. Se codice evento presente in lista visualizzo la campanella o meno a seconda della sottoscrizione, altrimenti popup di richiesta follow-up
  const ricercaEventiAssociati = (codiceEvento, firebaseToken) => {
    if (localStorage.getItem(NOTIFICATION_PERMISSION_SETTED) === "true") window.dispatchEvent(new CustomEvent(SUBSCRIBE_EVENT));
    else {
      axios({
        method: CHECK_SUBSCRIPTION_API.method,
        headers: { [NAVIGATION_FROM_REQUEST_HEADER]: "web" },
        data: { token: firebaseToken, eventId: codiceEvento },
        url: CHECK_SUBSCRIPTION_API.baseUrl + CHECK_SUBSCRIPTION_API.apiUrl,
      })
        .then((response) => {
          const eventIsSubscripted = response.data.isSubscr;
          if (eventIsSubscripted != null) {
            document.getElementById("subButton").style.display = eventIsSubscripted ? "flex" : "none";
            document.getElementById("unsubButton").style.display = eventIsSubscripted ? "none" : "flex";
          } else setFollowUpModalOpen(true);
        })
        .catch(() => {
          dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_CHECK_SUBSCRIPTION_ERROR_TITLE, description: SAGAS_CHECK_SUBSCRIPTION_ERROR_DESCRIPTION })); // prettier-ignore
          setFollowUpModalOpen(true);
        });
    }
  };

  // Funzione associata al listener di fine evento per interrompere il polling e mostrare la modale di fine evento
  const handleEventCompletion = () => {
    setEventCompleted(true);
    clearInterval(pollingInterval.current);
  };

  // Funzione associata al listener di subscribe. Se chiamata ok mostro campanella, se ko mostro notifica toast
  const handleSubscription = () => 
    axios({
      method: SUBSCRIBE_API.method,
      headers: { [NAVIGATION_FROM_REQUEST_HEADER]: "web" },
      data: { token: firebaseToken, eventId: monitoraggio[CODICE_EVENTO], lang: locale.slice(0,2)},
      url: SUBSCRIBE_API.baseUrl + SUBSCRIBE_API.apiUrl,
    })
      .then(() => {
        document.getElementById("subButton").style.display = "flex";
        document.getElementById("unsubButton").style.display = "none";
      })
      .catch(() => dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_SUBSCRIPTION_ERROR_TITLE, description: SAGAS_SUBSCRIPTION_ERROR_DESCRIPTION }))); // prettier-ignore

  // Funzione associata al listener di unsubscribe. Se chiamata ok mostro campanella sbarrata, se ko mostro notifica toast
  const handleUnsubscription = () =>
    axios({
      method: UNSUBSCRIBE_API.method,
      headers: { [NAVIGATION_FROM_REQUEST_HEADER]: "web" },
      data: { token: firebaseToken, eventId: monitoraggio[CODICE_EVENTO] },
      url: UNSUBSCRIBE_API.baseUrl + UNSUBSCRIBE_API.apiUrl,
    })
      .then(() => {
        document.getElementById("subButton").style.display = "none";
        document.getElementById("unsubButton").style.display = "flex";
      })
      .catch(() =>
        dispatch(
          setNotification({
            tipo: notificationCodes.ERROR,
            message: SAGAS_UNSUBSCRIPTION_ERROR_TITLE,
            description: SAGAS_UNSUBSCRIPTION_ERROR_DESCRIPTION,
          })
        )
      );

  const handleModalClose = () => setGoogleMapsModalOpen(false);

  const handleModalOk = () => {
    window.open(
      GOOGLE_MAPS_BASE_URL +
        ps[INDIRIZZO_OSPEDALE_JSON].toString().replaceAll(" ", "+") +
        (ps[CIVICO_OSPEDALE_JSON] != null ? ",+" + ps[CIVICO_OSPEDALE_JSON] : "") +
        ",+" +
        ps[CAP_OSPEDALE_JSON] +
        "+" +
        ps[COMUNE_OSPEDALE_JSON] +
        "+" +
        ps[PROVINCIA_OSPEDALE_JSON],
      "_blank"
    );
    handleModalClose();
  };

  return (
    <>
      {monitoraggio && (
        <>
          <Box className="headerMonitoraggio" />
          <Grid container className="monitoraggio">
            <Grid size={12} className="headerInfo">
              <Button
                startIcon={<ArrowBackIosNewOutlinedIcon />}
                onClick={() => {
                  navigate(PATH_HOME);
                  dispatch(azzeraMonitoraggio());
                }}
              >
                {getMessageString(intl, BACK)}
              </Button>
              <Grid container spacing={0.5} className="info" columns={12}>
                <Grid size={12} className="infoBox">
                  <Typography className="infoLabel" sx={{ fontSize: "1.2rem" }}>
                    {monitoraggio[INIZIALI_PAZIENTE] + " - " + monitoraggio[CODICE_EVENTO]}
                  </Typography>
                </Grid>
                <Grid size={12} className={"infoBox" + (!lodash.isEmpty(openedNotification[PS_CHANGED]) ? " encounterUpdate" : "")}>
                  <Typography className="infoLabel">{getMessageString(intl, PRONTO_SOCCORSO)}</Typography>
                  {ps ? (
                    <Tooltip title={getMessageString(intl, NAVIGA)} placement="top" arrow>
                      <Button startIcon={<LocationOnIcon />} onClick={() => setGoogleMapsModalOpen(true)}>
                        {ps[NOME_OSPEDALE_JSON] + " - " + ps[INDIRIZZO_OSPEDALE_JSON] + " " + ps[CIVICO_OSPEDALE_JSON]}
                      </Button>
                    </Tooltip>
                  ) : (
                    "-"
                  )}
                </Grid>
                <Grid
                  size={{ xs: 12, md: 7 }}
                  className={"infoBox" + (!lodash.isEmpty(openedNotification[CODICE_COLORE_CHANGED]) ? " encounterUpdate" : "")}
                >
                  <Typography className="infoLabel">{getMessageString(intl, CODICE_EMERGENZA)}</Typography>
                  {!lodash.isEmpty(monitoraggio[CODICE_COLORE]) ? <CodiceTriage codice={monitoraggio[CODICE_COLORE]} /> : "-"}
                </Grid>
                <Grid size={{ xs: 0, md: 1 }}></Grid>
                <Grid
                  size={{ xs: 12, md: 4 }}
                  className={"infoBox" + (!lodash.isEmpty(openedNotification[STATO_PAZIENTE_CHANGED]) ? " encounterUpdate" : "")}
                >
                  <Typography className="infoLabel">{getMessageString(intl, STATO_PAZIENTE)}</Typography>
                  <Typography>
                    {getMessageString(intl, PREFIX_STATO_PAZIENTE + monitoraggio[STATO], monitoraggio[ARGOMENTI_STATO_O_DIALOG])}
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 7 }}
                  className={"infoBox" + (!lodash.isEmpty(openedNotification[POSIZIONE_CHANGED]) ? " encounterUpdate" : "")}
                >
                  <Typography className="infoLabel">{getMessageString(intl, POSIZIONE)}</Typography>
                  {!lodash.isEmpty(monitoraggio[LUOGO]) ? (
                    <Stack>
                      {monitoraggio[LUOGO].map((luogo, index) => (
                        <Typography key={index}>{luogo}</Typography>
                      ))}
                    </Stack>
                  ) : (
                    "-"
                  )}
                </Grid>
                <Grid size={{ xs: 0, md: 1 }}></Grid>
                <Grid size={{ xs: 12, md: 4 }} className="infoBox">
                  <Typography className="infoLabel">{getMessageString(intl, ACCESSO_PS)}</Typography>
                  <Typography>{monitoraggio[TIMESTAMP_TRIAGE]}</Typography>
                </Grid>
                {monitoraggio[CODICE_MESSAGGIO] != null && monitoraggio[CODICE_DIALOG] == null && (
                  <Grid size={12} className="messaggio">
                    <Typography>
                      {getMessageString(intl, PREFIX_MESSAGGIO + monitoraggio[CODICE_MESSAGGIO], {
                        ...estraiParametriFineEpisodio(monitoraggio, config),
                      })}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid size={12} className="banners">
              <Banners />
            </Grid>
            <Grid size={12} className="lastUpdate">
              <Typography>{getMessageString(intl, LAST_UPDATE) + monitoraggio[LAST_UPDATE_TIMESTAMP]}</Typography>
            </Grid>
            <Grid size={12} className="monitoraggioBody">
              <Stack className="prestazioniLabel">
                <Icona tipologia="referto" />
                <Typography>{getMessageString(intl, PRESTAZIONI_LABEL)}</Typography>
              </Stack>
              <Tridimensional timeline={monitoraggio[PRESTAZIONI]} />
            </Grid>
          </Grid>
          {googleMapsModalOpen && <GoogleMapsModalAlert modalOpen={true} handleClose={handleModalClose} handleOk={handleModalOk} />}
          {monitoraggio[CODICE_DIALOG] != null && (
            <ModaleEventiMonitoraggio
              id="messaggioUtente"
              modalOpen={monitoraggio[CODICE_DIALOG] != null}
              text={[
                getMessageString(intl, PREFIX_DIALOG + monitoraggio[CODICE_DIALOG], monitoraggio[ARGOMENTI_STATO_O_DIALOG]),
                ...(monitoraggio[CODICE_MESSAGGIO] != null
                  ? [
                      getMessageString(intl, PREFIX_MESSAGGIO + monitoraggio[CODICE_MESSAGGIO], {
                        ...estraiParametriFineEpisodio(monitoraggio, config),
                      }),
                    ]
                  : []),
              ]}
            />
          )}
        </>
      )}
      {eventCompleted && <ModaleEventiMonitoraggio id="fineEvento" modalOpen={true} text={[getMessageString(intl, EVENT_COMPLETED_LABEL)]} />}
      {followUpModalOpen && <ModaleFollowUp modalOpen={true} onClose={() => setFollowUpModalOpen(false)} />}
      <LoadingSpinner loading={!fetchEnded} />
    </>
  );
});
